import Swiper from "swiper";
import "swiper/css";
import "./testimonials.css";

window.addEventListener("DOMContentLoaded", () => {
	new Swiper(".wp-block-des-testimonials", {
		slidesPerView: 1.2,
		centeredSlides: false,
		keyboard: true,
		cssMode: true,
		breakpoints: {
			768: {
				slidesPerView: 1.8,
			},
			1024: {
				slidesPerView: 2.4,
			},
			1440: {
				slidesPerView: 2.8,
			},
		},
	});
});
